module.exports = __webpack_public_path__ + "static/media/leaf-left.ee9be0fc.png";